export default "__VITE_PUBLIC_ASSET__9e96502b__"